module.exports = __webpack_public_path__ + "img/wrapbg4.0503ce32.png";